export interface ControlsHandlers {
  readonly onFile: (file: File) => void;
  readonly onMicrophone: () => void;
}

function requireElement<T extends HTMLElement>(id: string, ctor: new () => T): T {
  const element = document.querySelector(`#${id}`);
  if (!(element instanceof ctor)) {
    throw new TypeError(`Required element #${id} is missing from index.html`);
  }
  return element;
}

export function setStatus(text: string): void {
  requireElement('status', HTMLParagraphElement).textContent = text;
}

export function hideOverlay(): void {
  requireElement('overlay', HTMLDivElement).classList.add('hidden');
}

/**
 * Wire up the pulse slider, on pages that have one. Pages without a
 * `#pulse-slider` element simply don't get the dial.
 */
export function bindPulse(onPulse: (value: number) => void): void {
  const slider = document.querySelector('#pulse-slider');
  if (!(slider instanceof HTMLInputElement)) {
    return;
  }
  slider.addEventListener('input', () => {
    const value = Number(slider.value);
    if (Number.isFinite(value)) {
      onPulse(value);
    }
  });
}

/** Wire up the file picker, microphone button, and whole-window drag & drop. */
export function bindControls(handlers: ControlsHandlers): void {
  const fileInput = requireElement('file-input', HTMLInputElement);
  const fileButton = requireElement('file-button', HTMLButtonElement);
  const micButton = requireElement('mic-button', HTMLButtonElement);

  fileButton.addEventListener('click', () => {
    fileInput.click();
  });

  fileInput.addEventListener('change', () => {
    const file = fileInput.files?.[0];
    if (file !== undefined) {
      handlers.onFile(file);
    }
  });

  micButton.addEventListener('click', () => {
    handlers.onMicrophone();
  });

  globalThis.addEventListener('dragover', (event) => {
    event.preventDefault();
  });

  globalThis.addEventListener('drop', (event) => {
    event.preventDefault();
    const file = event.dataTransfer?.files[0];
    if (file?.type.startsWith('audio/') === true) {
      handlers.onFile(file);
    }
  });
}
